export default "https://cdn.questicon.mathletics.com/assets/images/whale_mountain-3c2c3a04eed34fd47a5468b75934fbd5.png";